"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconPowerToGas = function IconPowerToGas(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "m24.666 5.382 1.295 1.686.926 1.236a140 140 0 0 1 2.678 3.733 100 100 0 0 1 1.726 2.582l.292.458C35.367 21.064 37.3 25.643 37.3 28.79 37.3 36.628 31.318 43 23.88 43c-7.434 0-13.41-6.368-13.42-14.21 0-3.232 2.027-7.951 6.009-14.17q.268-.42.555-.852.556-.843 1.17-1.73a145 145 0 0 1 3.834-5.273l.642-.838 1.21-1.544zm-1.272 2.893-.913 1.22a138 138 0 0 0-2.641 3.68 98 98 0 0 0-1.688 2.524c-3.788 5.917-5.692 10.35-5.692 13.09C12.47 35.553 17.58 41 23.88 41c6.304 0 11.42-5.449 11.42-12.21 0-2.663-1.812-6.956-5.406-12.641l-.287-.453-.54-.826a98 98 0 0 0-1.147-1.695 143 143 0 0 0-3.32-4.59l-.72-.95zM24.21 33c.84 0 1.33.42 1.33 1.09a1.48 1.48 0 0 1-.67 1.17l-.61.51h1.32v.91H22.9v-.83l1.16-1 .021-.019c.203-.184.41-.37.41-.611a.28.28 0 0 0-.311-.29.34.34 0 0 0-.36.38h-1A1.21 1.21 0 0 1 24.21 33m4.45-5.06a3.14 3.14 0 0 1 3.26 3.24 3.25 3.25 0 1 1-3.26-3.24m-10.74 2.54h2.95v-2.41H22v6.22h-1.13v-2.73h-2.95v2.73h-1.14v-6.22h1.14zm10.73-1.38a2 2 0 0 0-1.99 2.08h-.01a2 2 0 1 0 2-2.08M24.5 18l3.5-1-5.5 9 1-6-3.5 1 6-9z"
  })));
};

export { IconPowerToGas, IconPowerToGas as default };
